<template>
  <SustainabilityTab :product="product" :esg-subscription="esgSubscription" />
</template>

<script lang="ts" setup>
import SustainabilityTab from '~/components/reports/SustainabilityTab.vue'
import type { TProduct } from '~/src/types/product'
/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  esgSubscription: string
}>()
</script>
